<template>
  <div class="chart-time-select2">
    <el-radio-group v-model="chartTimeSelectRadio" size="mini">
      <el-radio-button label="HOUR">按时</el-radio-button>
      <el-radio-button label="DAY">按日</el-radio-button>
      <el-radio-button label="MONTH">按月</el-radio-button>
    </el-radio-group>
    <el-date-picker v-if="chartTimeSelectRadio === 'DAY'" v-model="timeValue" style="width: 320px" size="mini" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
    <el-date-picker v-if="chartTimeSelectRadio === 'MONTH'" v-model="timeValue" style="width: 320px" size="mini" type="monthrange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" value-format="yyyy-MM"></el-date-picker>
    <el-date-picker v-if="chartTimeSelectRadio === 'HOUR'" v-model="timeValue" style="width: 320px" size="mini" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:00:00"></el-date-picker>
  </div>
</template>

<script>
export default {
  name: "ChartTimeSelect2",
  props: {
    // chartTimeSelectRadio: {
    //   type: String,
    //   default() {
    //     return 'DAY'
    //   }
    // },
    // timeValue: {
    //   type: Array,
    //   default() {
    //     return []
    //   }
    // }
  },
  data() {
    return {
      chartTimeSelectRadio: "HOUR",
      timeValue: []
    };
  },
  created() {
    this.getCreateTime();
  },
  methods: {
    getCreateTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour = nowDate.getHours();
      let lastDate = new Date(nowDate - 1000 * 60 * 60 * 24 * 30);
      let lastYear = lastDate.getFullYear();
      let lastMonth =
        lastDate.getMonth() + 1 < 10
          ? "0" + (lastDate.getMonth() + 1)
          : lastDate.getMonth() + 1;
      let lastDay =
        lastDate.getDate() < 10 ? "0" + lastDate.getDate() : lastDate.getDate();
      let timeValue = [
        `${year}-${month}-${date} 00:00:00`,
        `${year}-${month}-${date} 24:00:00`
      ];
      this.timeValue = timeValue;
    },
    getTableData() {
      let startTime = "",
        endTime = "";
      if (this.timeValue) {
        startTime = this.timeValue[0];
        endTime = this.timeValue[1];
      }
      this.$emit("getData", this.chartTimeSelectRadio, startTime, endTime);
    }
  },
  watch: {
    chartTimeSelectRadio(val) {
      console.log(val);
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      var hour = nowDate.getHours();
      if (this.chartTimeSelectRadio === "DAY") {
        this.timeValue[0] = `${year}-${month}-01`;
        this.timeValue[1] = `${year}-${month}-${date}`;
      } else if (this.chartTimeSelectRadio === "MONTH") {
        this.timeValue[0] = `${year}-01`;
        this.timeValue[1] = `${year}-${month}`;
      } else {
        this.timeValue[0] = `${year}-${month}-${date} 00:00:00`;
        this.timeValue[1] = `${year}-${month}-${date} 24:00:00`;
      }
      this.getTableData();
    },
    timeValue(val) {
      this.getTableData();
    }
  }
};
</script>

<style scoped lang="less">
.chart-time-select2 {
  width: 550px;
  position: absolute;
  top: 15px;
  right: 0;
  left: 0;
  margin: 0 auto;
  z-index: 1001;
}
/deep/ .el-date-editor .el-range-separator {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Echarts/ChartTimeSelect2/ChartTimeSelect2.vue